import React, { useState } from "react";
import { Paper, Grid } from "@material-ui/core";
import {
  InputTextMaster,
  MasterButton,
  InputOptionMaster,
  InputCheckboxMaster,
  InputAsyncOptionMaster,
} from "App/Component/ui";
import {
  RESET_STATE_MASTER_BARANG,
  STYLE_MASTER_BARANG,
  SelectOptionDataMasterBarang,
  urlCreate,
  urlUpdate,
  validation,
  urlUpdateHPP,
} from ".";
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance4,
  TYPE_INSTANCE4,
  TYPE_SATU_SEHAT,
} from "App/constants";
import {
  convertToValidPrice,
  defaultToastError,
  defaultToastSuccess,
  fetchData,
  // formatNumber,
  formatRupiah,
  isNull,
} from "App/utils/helpers";
import { useSelectOption } from "App/hooks";
import { LIST_URL_WAREHOUSE } from "utils/warehouse";
import { v4 as uuidv4 } from "uuid";

export default function FormMasterGudang({
  access,
  formData,
  setFormData,
  barangId,
  setNewData,
  handleClickReset,
}) {
  const classes = STYLE_MASTER_BARANG();

  const {
    jenisObat,
    golonganObat,
    formula,
    asuransi,
    kelasTerapi,
    produsen,
    satuan,
  } = SelectOptionDataMasterBarang();

  const buttonUpdate = {
    label: "Update HPP & Harga Beli",
    color: "warning",
    state: false,
    disabled: false,
  };

  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);
  const [disabled2, setDisabled2] = useState(buttonUpdate);

  const add = async () => {
    return instance4.post(urlCreate, {
      ...formData,
      tarifcbg_id: formData.id_tarif_cbg,
    });
  };

  const update = () => {
    return instance4.post(urlUpdate, {
      id: barangId,
      ...formData,
      tarifcbg_id: formData.id_tarif_cbg,
    });
  };

  const updateHPPBarang = async () => {
    return instance4.post(urlUpdateHPP, {
      id: barangId,
      hargapokok: formData.harga_pokok,
      hargabeli: formData.hargabeli,
    });
  };

  const updateHPP = async () => {
    setDisabled(DISABLED_BUTTON_SUBMIT);
    setDisabled2(DISABLED_BUTTON_SUBMIT);
    try {
      const api = await updateHPPBarang();
      const res = api.data;
      if (res.status === 200) {
        defaultToastSuccess("Berhasil memperbarui HPP dan Harga Beli");
        setFormData(RESET_STATE_MASTER_BARANG);
        setNewData();
      } else {
        defaultToastError(res.message);
      }
    } catch (error) {
      defaultToastError(error?.response?.data?.message);
    }
    setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
    setDisabled2(buttonUpdate);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    setDisabled2(DISABLED_BUTTON_SUBMIT);
    // const validation

    const valid = validation(formData);
    if (valid.state) {
      try {
        if (isNull(barangId)) {
          const res = await add();
          if (res.data.status === 200) {
            remove();
            defaultToastSuccess("Berhasil menambah barang");
            setNewData();
          } else {
            defaultToastError(res?.data?.message);
          }
        } else if (!isNull(barangId)) {
          if (
            formData.harga_pokok !== formData.harga_pokokAwal &&
            access === false
          ) {
            defaultToastError("Anda tidak memiliki akses untuk mengubah HPP !");
          } else {
            if (
              formData.hargabeli !== formData.hargabeliAwal &&
              access === false
            ) {
              defaultToastError(
                "Anda tidak memiliki akses untuk mengubah Harga Beli !"
              );
            } else {
              const res = await update();
              if (res.data.status === 200) {
                remove();
                defaultToastSuccess("Berhasil mengubah barang");
                setDisabled2(buttonUpdate);
                setNewData();
              } else {
                defaultToastError(res?.data?.message);
              }
            }
          }
        }
      } catch (error) {
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        setDisabled2(buttonUpdate);
        defaultToastError(error?.response?.data?.message);
      }
    } else {
      defaultToastError(valid.message);
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      setDisabled2(buttonUpdate);
    }
  };

  const remove = () => {
    setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
    setFormData(RESET_STATE_MASTER_BARANG);
  };

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  const handleChangeNumber = (text) => (e) => {
    const result = e.target.value
      .replace(/[^0-9.]/g, "")
      .replace(/(\..*?)\..*/g, "$1");
    setFormData({
      ...formData,
      [text]: result,
    });
  };

  const tarifCBG = useSelectOption(
    true,
    LIST_URL_WAREHOUSE.masterTarifCbg.get,
    TYPE_INSTANCE4,
    "id",
    "name",
    "data"
  );

  const preLoadData = async (inputValue) => {
    const res = await fetchData(
      TYPE_SATU_SEHAT,
      "/satu-sehat/kfa/products/search_satu-sehat",
      "data",
      {
        params: {
          sort_by: "display_name",
          sort_key: "asc",
          pages: 1,
          limit: 50,
          search_key: isNull(inputValue) ? "" : inputValue,
        },
      }
    );

    if (res) {
      const data = [];

      res.map((item) => {
        return data.push({
          value: item.kode_kfa,
          label: `${item.kode_kfa} - ${item.display_name}`,
        });
      });
      return data;
    } else {
      return [];
    }
  };

  return (
    <Paper className={classes.paper}>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={3}>
          <Grid item sm={2}>
            <InputTextMaster
              name='id'
              label='ID'
              id='id'
              value={barangId}
              onChange={handleChange("id")}
              placeholder='ID'
              disabled={true}
            />
          </Grid>
          <Grid item sm={2}>
            <InputTextMaster
              name='kode_produk'
              label='KODE PRODUK'
              id='kode_produk'
              value={formData.kode_produk}
              onChange={handleChange("kode_produk")}
              placeholder='Kode Produk'
            />
          </Grid>
          <Grid item sm={3}>
            <InputTextMaster
              name='name'
              label='NAMA BARANG'
              id='name'
              value={formData.name}
              onChange={handleChange("name")}
              placeholder='Nama Barang'
            />
          </Grid>
          <Grid item sm={2}>
            <InputTextMaster
              name='barcode'
              label='BARCODE'
              id='barcode'
              value={formData.barcode}
              onChange={handleChange("barcode")}
              placeholder='Barcode'
            />
          </Grid>
          <Grid item sm={3}>
            <InputTextMaster
              name='komposisi'
              label='KOMPOSISI'
              id='komposisi'
              value={formData.komposisi}
              onChange={handleChange("komposisi")}
              placeholder='Komposisi'
            />
          </Grid>
        </Grid>

        <div className='mt-1'>
          <Grid container spacing={3}>
            <Grid item sm={3}>
              <InputOptionMaster
                name='produsen_id'
                label='PRODUSEN'
                id='produsen_id'
                withSearch={true}
                data={produsen}
                value={formData.produsen_id}
                labelValue={formData.produsen_name}
                onChange={(e) => {
                  if (isNull(e)) {
                    setFormData({
                      ...formData,
                      produsen_id: null,
                      produsen_name: "Pilih Produsen",
                    });
                  } else {
                    setFormData({
                      ...formData,
                      produsen_id: e.value,
                      produsen_name: e.label,
                    });
                  }
                }}
              />
            </Grid>

            <Grid item sm={3}>
              <InputOptionMaster
                name='kelasterapi_id'
                label='KELAS TERAPI'
                id='kelasterapi_id'
                withSearch={true}
                data={kelasTerapi}
                value={formData.kelasterapi_id}
                labelValue={formData.kelasterapi_name}
                onChange={(e) => {
                  if (isNull(e)) {
                    setFormData({
                      ...formData,
                      kelasterapi_id: null,
                      kelasterapi_name: "Pilih Kelas Terapi",
                    });
                  } else {
                    setFormData({
                      ...formData,
                      kelasterapi_id: e.value,
                      kelasterapi_name: e.label,
                    });
                  }
                }}
              />
            </Grid>

            <Grid item sm={3}>
              <InputOptionMaster
                name='jenisobat_id'
                label='JENIS OBAT'
                id='jenisobat_id'
                withSearch={false}
                data={jenisObat}
                value={formData.jenisobat_id}
                onChange={handleChange("jenisobat_id")}
              />
            </Grid>

            <Grid item sm={3}>
              <InputOptionMaster
                name='golongan_id'
                label='GOLONGAN OBAT'
                id='golongan_id'
                withSearch={false}
                data={golonganObat}
                value={formData.golongan_id}
                onChange={handleChange("golongan_id")}
              />
            </Grid>
          </Grid>
        </div>

        <div className='mt-1'>
          <Grid container spacing={3}>
            <Grid item sm={3}>
              <InputTextMaster
                name='harga_pokok'
                label='HARGA POKOK'
                id='harga_pokok'
                disabled={isNull(barangId) ? false : access ? false : true}
                placeholder='Harga Pokok'
                value={formData.harga_pokok2}
                onChange={
                  isNull(barangId) || access
                    ? (e) => {
                      setFormData({
                        ...formData,
                        harga_pokok: convertToValidPrice(e.target.value),
                        harga_pokok2: formatRupiah(e.target.value),
                      });
                    }
                    : null
                }
              />
            </Grid>

            <Grid item sm={3}>
              <InputTextMaster
                name='harga_beli'
                label='HARGA BELI'
                id='harga_beli'
                disabled={isNull(barangId) ? false : access ? false : true}
                placeholder='Harga Beli'
                value={formData.hargabeli2}
                onChange={
                  isNull(barangId) || access
                    ? (e) => {
                      setFormData({
                        ...formData,
                        hargabeli: convertToValidPrice(e.target.value),
                        hargabeli2: formatRupiah(e.target.value),
                      });
                    }
                    : null
                }
              />
            </Grid>

            <Grid item sm={3}>
              <InputTextMaster
                name='qty'
                label='QTY'
                id='qty'
                disabled={true}
                readOnly={true}
                placeholder='Harga Pokok'
                value={formData.qty}
              />
            </Grid>
            <Grid item sm={3}>
              <InputTextMaster
                name='persediaan'
                label='PERSEDIAAN'
                id='persediaan'
                disabled={true}
                readOnly={true}
                placeholder='Persediaan'
                value={formData.persediaan}
              />
            </Grid>
          </Grid>
        </div>

        <div className='mt-1'>
          <Grid container spacing={3}>
            <Grid item sm={3}>
              <InputTextMaster
                name='stockmin'
                label='STOCK MIN'
                id='stockmin'
                placeholder='Stock Min'
                value={formData.stockmin}
                onChange={handleChangeNumber("stockmin")}
              />
            </Grid>

            <Grid item sm={3}>
              <InputTextMaster
                name='stockmax'
                label='STOCK MAX'
                id='stockmax'
                placeholder='Stock Max'
                value={formData.stockmax}
                onChange={handleChangeNumber("stockmax")}
              />
            </Grid>

            <Grid item sm={3}>
              <InputTextMaster
                name='nilaikritis'
                label='STOK KRITIS'
                id='nilaikritis'
                placeholder='Stock Kritis'
                value={formData.nilaikritis}
                onChange={handleChangeNumber("nilaikritis")}
              />
            </Grid>
            <Grid item sm={3}>
              <InputOptionMaster
                name='golcoa_id'
                label='Golongan Coa'
                id='golcoa_id'
                withSearch={false}
                disabled={true}
                data={asuransi}
                value={formData.golcoa_id}
                onChange={handleChange("golcoa_id")}
              />
            </Grid>
          </Grid>
        </div>

        <div className='mt-1'>
          <Grid container spacing={3}>
            {/* <Grid item sm={3}>
              <InputOptionMaster
                name='insurance_id'
                label='ASURANSI'
                id='insurance_id'
                withSearch={false}
                data={asuransi}
                value={formData.insurance_id}
                onChange={handleChange("insurance_id")}
              />
            </Grid> */}

            <Grid item sm={3}>
              <InputOptionMaster
                name='id_tarif_cbg'
                label='TARIF CBG'
                id='id_tarif_cbg'
                withSearch={true}
                data={tarifCBG}
                value={formData.id_tarif_cbg}
                labelValue={formData.tarif_cbg}
                onChange={(e) => {
                  if (isNull(e)) {
                    setFormData({
                      ...formData,
                      id_tarif_cbg: null,
                      tarif_cbg: "Pilih CBG",
                    });
                  } else {
                    setFormData({
                      ...formData,
                      id_tarif_cbg: e.value,
                      tarif_cbg: e.label,
                    });
                  }
                }}
              />
            </Grid>

            <Grid item sm={3}>
              {/* <InputOptionMaster
                name='formula_id'
                label='Formula'
                id='formula_id'
                withSearch={false}
                data={formula}
                value={formData.formula_id}
                onChange={handleChange("formula_id")}
              /> */}

              <InputOptionMaster
                name='formula_id'
                label='FORMULA'
                id='formula_id'
                withSearch={true}
                data={formula}
                value={formData.formula_id}
                labelValue={formData.formula_name}
                onChange={(e) => {
                  if (isNull(e)) {
                    setFormData({
                      ...formData,
                      formula_id: null,
                      formula_name: "Pilih Formula",
                    });
                  } else {
                    setFormData({
                      ...formData,
                      formula_id: e.value,
                      formula_name: e.label,
                    });
                  }
                }}
              />
            </Grid>
            <Grid item sm={3}>
              <InputOptionMaster
                name='satuanbeli_id'
                label='SATUAN BELI'
                id='satuanbeli_id'
                withSearch={true}
                data={satuan}
                value={formData.satuanbeli_id}
                labelValue={formData.satuanbeli_name}
                onChange={(e) => {
                  if (isNull(e)) {
                    setFormData({
                      ...formData,
                      satuanbeli_id: null,
                      satuanbeli_name: "Pilih Satuan Beli",
                    });
                  } else {
                    setFormData({
                      ...formData,
                      satuanbeli_id: e.value,
                      satuanbeli_name: e.label,
                    });
                  }
                }}
              />
            </Grid>

            <Grid item sm={3}>
              <InputOptionMaster
                name='satuanjual_id'
                label='SATUAN JUAL'
                id='satuanjual_id'
                withSearch={true}
                data={satuan}
                value={formData.satuanjual_id}
                labelValue={formData.satuanjual_name}
                onChange={(e) => {
                  if (isNull(e)) {
                    setFormData({
                      ...formData,
                      satuanjual_id: null,
                      satuanjual_name: "Pilih Satuan Jual",
                    });
                  } else {
                    setFormData({
                      ...formData,
                      satuanjual_id: e.value,
                      satuanjual_name: e.label,
                    });
                  }
                }}
              />
            </Grid>
          </Grid>
        </div>

        {/* Dibuat semacam card biar tau apa aja yang di ambil dari KFA.  */}

        <div className='mt-2' style={{
          border: '1px solid #EAEAEA',
          backgroundColor: '#F7F7F7',
          paddingTop: '15px',
          paddingBottom: '25px',
          paddingLeft: '13px',
          paddingRight: '13px',
          borderRadius: '4px'
        }}>
          <Grid container spacing={3}>
            <Grid item md>
              <InputTextMaster
                name='kode_kfa_pa'
                label='KODE KFA POA'
                id='kode_kfa_pa'
                placeholder='KODE KFA POA'
                value={formData.kode_kfa_pa}
                onChange={handleChangeNumber("kode_kfa_pa")}
              />
            </Grid>
            <Grid item md>
              <InputAsyncOptionMaster
                label='KODE KFA PV'
                name='kode_kfa_pv'
                id={uuidv4()}
                needParse={false}
                withSearch={true}
                data={[]}
                loadOptions={preLoadData}
                value={formData.kode_kfa_pv}
                labelValue={formData.kode_kfa_pv_label}
                defaultData={formData.kode_kfa_pv}
                onChange={(e) => {
                  if (isNull(e)) {
                    setFormData({
                      ...formData,
                      kode_kfa_pv: "",
                      kode_kfa_pv_label: "Pilih Kode KFA",
                    });
                  } else {
                    setFormData({
                      ...formData,
                      kode_kfa_pv: e.value,
                      kode_kfa_pv_label: e.label,
                    });
                  }
                }}
              />
            </Grid>
            <Grid item md>
              <InputTextMaster
                name='bahan_baku_zat_aktif_kode_kfa_pa'
                label='BAHAN BAKU ZAT AKTIF KODE KFA PA '
                id='bahan_baku_zat_aktif_kode_kfa_pa'
                value={formData.bahan_baku_zat_aktif_kode_kfa_pa}
                onChange={handleChange("bahan_baku_zat_aktif_kode_kfa_pa")}
                placeholder='Bahan Baku Zat Aktif Kode KFA PA'
              />
            </Grid>
            <Grid item md>
              <InputTextMaster
                name='bahan_baku_numerator'
                label='BAHAN BAKU NUMERATOR'
                id='bahan_baku_numerator'
                value={formData.bahan_baku_numerator}
                onChange={handleChange("bahan_baku_numerator")}
                placeholder='Bahan Baku Numerator'
              />
            </Grid>

            <Grid item md>
              <InputTextMaster
                name='bentuk_sediaan_kode'
                label='KODE BENTUK SEDIAAN'
                id='bentuk_sediaan_kode'
                value={formData.bentuk_sediaan_kode}
                onChange={handleChange("bentuk_sediaan_kode")}
                placeholder='Kode Bentuk Sediaan'
              />
            </Grid>
          </Grid>
        </div>

        <div className='mt-1'>
          <Grid container spacing={3}>

            <Grid item sm={2}>
              <InputTextMaster
                name='qjb'
                label='QJB'
                id='qjb'
                value={formData.qjb}
                onChange={handleChange("qjb")}
                placeholder='Qjb'
              />
            </Grid>
            <Grid item sm={1}>
              <div
                style={{
                  marginTop: "1.5rem",
                }}>
                <InputCheckboxMaster
                  checked={formData.status}
                  name='status'
                  id='status'
                  label='Aktif'
                  onChange={() =>
                    setFormData({ ...formData, status: !formData.status })
                  }
                />
              </div>
            </Grid>

            <Grid item sm={2}>
              <div
                style={{
                  marginTop: "1.5rem",
                }}>
                <InputCheckboxMaster
                  checked={formData.isformula}
                  name='isformula'
                  id='isformula'
                  label='Menggunakan Formula'
                  onChange={() =>
                    setFormData({ ...formData, isformula: !formData.isformula })
                  }
                />
              </div>
            </Grid>

            <Grid item sm={2}>
              <div
                style={{
                  marginTop: "1.5rem",
                }}>
                <InputCheckboxMaster
                  checked={formData.is_formularium}
                  name='is_formularium'
                  id='is_formularium'
                  label='Formularium'
                  onChange={() =>
                    setFormData({
                      ...formData,
                      is_formularium: !formData.is_formularium,
                    })
                  }
                />
              </div>
            </Grid>
          </Grid>
        </div>

        <div className='mt-2'>
          <hr style={{ margin: "1rem 0", opacity: "0.3" }} />
          <Grid
            container
            direction='row'
            justifyContent='space-between'
            alignItems='center'>
            <MasterButton
              outline={true}
              type={"button"}
              onClick={() => handleClickReset()}
              color='danger'
              name='Reset'
              size='md'
            />
            <div style={{ display: "flex", gap: "10px" }}>
              {!isNull(barangId) && access ? (
                <MasterButton
                  outline={false}
                  type={"button"}
                  disabled={disabled2.state}
                  color={disabled2.color}
                  name={disabled2.label}
                  size='md'
                  onClick={() => updateHPP()}
                />
              ) : (
                <></>
              )}
              <MasterButton
                outline={false}
                type={"submit"}
                disabled={disabled.state}
                color={disabled.color}
                name={disabled.label}
                size='md'
              />
            </div>
          </Grid>
        </div>
      </form>
    </Paper>
  );
}
